// extracted by mini-css-extract-plugin
export default {"zoomModal":"D4-z"};